export default __webpack_public_path__ + "static/media/Inácio Krauss.7bacc3f8.jpg";